// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2kZWk","title":"Images90_title__2Ki0x","images":"Images90_images__Wh8IA"};